/* eslint-disable no-param-reassign */
import produce from 'immer';
import initialState from 'redux/reducers/clonotypes/initialState';
var clonotypesLoading = produce(function (draft) {
  draft.loading = true;
  draft.error = false;
  draft.initialLoadPending = false;
}, initialState);
export default clonotypesLoading;